import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import FieldContainer from 'refactored/features/soForm/steps/card/creditCard/Form/components/FieldContainer/container';

export default styled(FieldContainer)`
  background: #ffffff;
  width: 100%;
  max-width: 100%;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  padding: ${gridSizes('S')} 0px;



  .StripeElement {
    height: 4.8rem;
    width: 100%;
    font-size: 1.6rem;
    padding-top: 2.5rem;
    padding-right: 3.2rem;
    padding-bottom: 0.2rem;
    padding-left: 1.2rem;
    color: var(--grey900);
    border: 1px solid var(--grey500);
    background: transparent;
    position: relative;
  }

  label {
    font-size: 1.4rem;
    color: var(--grey700);
    -webkit-transform: translate(0, -20%);
    -ms-transform: translate(0, -20%);
    transform: translate(0, -20%);
    font-size: 1.4rem;
    pointer-events: none;
    position: absolute;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: absolute;
    top: 3px;
    left: 0;
    height: 100%;
    padding: 1.6rem 1.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
  }

  input:focus,
  .StripeElement--focus {
    border: solid 1px var(--primary500);
    box-shadow: inset 0 0 0 1px var(--primary500);
    -webkit-transition: all 150ms ease;
    transition: all 150ms ease;
  }




  input::placeholder {
    color: #aab7c4;
  }

  &.error{
    label {
      color: var(--red-cherry-text);
    }
    input{
      color: var(--red-cherry-text);
    }

    .StripeElement {{
      border: solid 1px var(--red-cherry-text);
      box-shadow: inset 0 0 0 1px var(--red-cherry-text);
    }

    input::placeholder {
      color: var(--red-cherry-text);
    }


  }

`;
